// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table-container {
    padding: 16px;
    border-radius: 1rem;
    border: 1px solid rgba(161, 186, 209, 1);
  }
  
  .custom-table-container .ant-table-thead .ant-table-cell {
    background-color: #FFFFFF;
    color:rgba(0, 68, 129, 1);
    border-bottom: 2px solid #000000;
  }
  
  .ant-table-thead > tr > th {
    color:rgba(0, 68, 129, 1);
    text-align: center;
    font-weight: 600;
  }
  
  .ant-table-tbody > tr > td {
    text-align: center;
    padding: 10px;
    background-color:#FFFFFF; 
    color:rgba(0, 68, 129, 1);
    font-weight: 600;
    font-size: 12px;
  }
  
  .ant-table-tbody > tr:nth-child(odd) {
    background-color: #f1f8ff; 
  }
  
  .ant-progress-line {
    display: inline-block;
    width: 60px;
  }
  
  .ant-progress-inner {
    background-color: #e8e8e8;
  }
  
  .custom-table-container .ant-table-container {
    overflow: hidden;
  }
  :where(.css-dev-only-do-not-override-14qglws).ant-table-wrapper .ant-table-thead >tr>th, :where(.css-dev-only-do-not-override-14qglws).ant-table-wrapper .ant-table-thead >tr>td {
    color: rgba(0, 68, 129, 1);
    font-weight: bold;
    font-size: 12px;
    text-align: center;
  }
  :where(.css-dev-only-do-not-override-14qglws).ant-table-wrapper .ant-table {
    border-radius: 25px;
  }`, "",{"version":3,"sources":["webpack://./src/components/KpiDetailView/DetailViewTable.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB","sourcesContent":[".custom-table-container {\n    padding: 16px;\n    border-radius: 1rem;\n    border: 1px solid rgba(161, 186, 209, 1);\n  }\n  \n  .custom-table-container .ant-table-thead .ant-table-cell {\n    background-color: #FFFFFF;\n    color:rgba(0, 68, 129, 1);\n    border-bottom: 2px solid #000000;\n  }\n  \n  .ant-table-thead > tr > th {\n    color:rgba(0, 68, 129, 1);\n    text-align: center;\n    font-weight: 600;\n  }\n  \n  .ant-table-tbody > tr > td {\n    text-align: center;\n    padding: 10px;\n    background-color:#FFFFFF; \n    color:rgba(0, 68, 129, 1);\n    font-weight: 600;\n    font-size: 12px;\n  }\n  \n  .ant-table-tbody > tr:nth-child(odd) {\n    background-color: #f1f8ff; \n  }\n  \n  .ant-progress-line {\n    display: inline-block;\n    width: 60px;\n  }\n  \n  .ant-progress-inner {\n    background-color: #e8e8e8;\n  }\n  \n  .custom-table-container .ant-table-container {\n    overflow: hidden;\n  }\n  :where(.css-dev-only-do-not-override-14qglws).ant-table-wrapper .ant-table-thead >tr>th, :where(.css-dev-only-do-not-override-14qglws).ant-table-wrapper .ant-table-thead >tr>td {\n    color: rgba(0, 68, 129, 1);\n    font-weight: bold;\n    font-size: 12px;\n    text-align: center;\n  }\n  :where(.css-dev-only-do-not-override-14qglws).ant-table-wrapper .ant-table {\n    border-radius: 25px;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
